import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import router from './routes/config';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    {/* <PersistGate loading={null} persistor={persistor}>
      <HelmetProvider>
        <CacheProvider>
          <RouterProvider router={router} />
        </CacheProvider>
      </HelmetProvider>
    </PersistGate> */}
          <RouterProvider router={router} />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
